/** @format */

export const sessions = {
  setToken: async (token: string) => {
    sessionStorage.setItem('token', token);
  },
  getToken: () => {
    return sessionStorage.getItem('token');
  },
  removeToken: async () => sessionStorage.removeItem('token'),
};
